import { render, staticRenderFns } from "./address-fields.vue?vue&type=template&id=93a2561c&scoped=true&lang=pug"
import script from "./address-fields.vue?vue&type=script&lang=js"
export * from "./address-fields.vue?vue&type=script&lang=js"
import style0 from "./address-fields.vue?vue&type=style&index=0&id=93a2561c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a2561c",
  null
  
)

export default component.exports